import { MantineThemeOverride } from '@mantine/core';

export type ProjectConfig = {
  config: {
    headerLogo: string;
    footerLogo: string;
    termsOfServiceUrl: string;
    privacyPolicyUrl: string;
  };
  colorTheme: {
    colors: MantineThemeOverride['colors'];
    primaryButtonTextColor: string;
  };
};

const capricornConfig: ProjectConfig = {
  config: {
    headerLogo: 'CapricornLogo',
    footerLogo: 'CapricornTechSymbol',
    termsOfServiceUrl:
      'https://capricorn-tech.notion.site/Capricorn-Tech-Terms-of-Service-7079e2f8b4a24e6daf52141090fb15ea',
    privacyPolicyUrl:
      'https://capricorn-tech.notion.site/Capricorn-Tech-Privacy-Policy-9792521a7be44bcb8fb8e850980c4343',
  },
  colorTheme: {
    colors: {
      brand: [
        '#9AEEE6',
        '#3AECA7',
        '#121212',
        '#0A0B0D',
        '#0A242D',
        '#0A242D',
        '#0A242D',
        '#0A242D',
        '#0A242D',
        '#0A242D',
      ],
      dark: [
        '#F3F3F3',
        '#f3f3f399',
        '#f3f3f366',
        '#535258',
        '#302F34',
        '#1D1C20',
        '#0F0E12',
        '#080709',
        '#00434A',
        '#0A242D',
      ],
    },
    primaryButtonTextColor: 'var(--mantine-color-main-9)',
  },
};

export const projectConfigs: Record<string, ProjectConfig> = {
  default: capricornConfig,
  blue: capricornConfig,
};
